<template>
    <section class="comp_overview_occupancy">
        <div class="comp_content">
            <div class="header">
                <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle mod--flex-column"
                        style="border-bottom: none; margin-bottom: 0.6rem">
                    <div class="mod--row mod--row-flex mod--row-middle">
                        <div class="col">
                            <h1 class="part_ui_heading">
                                <span>{{ $t('occupancy_graph') }}</span></h1>
                        </div>
                    </div>
                    <div class="mod--row mod--row-flex mod--row-middle"
                         style="border-bottom: none; margin-bottom: 0">
                        <div class="col">
                            <div style="display: flex;">
                                <div class="labeled-toggle-button">
                                    <div :class="{item: true, selected: type === 'free'}"
                                         v-on:click="type = 'free'">{{ $t('occupancy_graph_free') }}
                                    </div>
                                    <div class="delimiter"/>
                                    <div :class="{item: true, selected: type === 'occupied'}"
                                         v-on:click="type = 'occupied'">{{ $t('occupancy_graph_occupied') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <DateInputHeader v-model="date"/>
            </div>
            <div class="wrp_comp_body" :class="[loading ? 'state-loading' : '']"
                 v-on:scroll="handleGlobalScroll($event)" ref="table">
                <div class="mod--row mod--row-4" style="min-height: 100px;margin-top: 10px">
                    <table v-if="data">
                        <thead>
                        <tr>
                            <th></th>
                            <th v-for="(d, index) in data.percentages" :key="index"
                                :class="{'selected': isSelected(data.dates[index])}">
                                {{ d }} %
                            </th>
                        </tr>
                        <tr>
                            <th></th>
                            <th v-for="(d, index) in data.dates" :key="index"
                                :class="{'sunday': isSunday(d), 'selected': isSelected(d)}">
                                {{ weekDay(d) }}
                            </th>
                        </tr>
                        <tr>
                            <th></th>
                            <th v-for="(d, index) in data.dates" :key="index"
                                :class="{'selected': isSelected(d)}">
                                <div :class="{'day':true,'sunday': isSunday(d), 'today': isToday(d)}">
                                    {{ day(d) }}
                                </div>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(d, index) in data.items" :key="index">
                            <td>{{ d.label }}</td>
                            <td v-for="(i, index) in d.occupancy" :key="index"
                                :class="{'selected': isSelected(data.dates[index])}">
                                {{ i }}
                            </td>
                        </tr>
                        <tr class="totals">
                            <td style="text-transform: uppercase">{{ $t('total') }}</td>
                            <td v-for="(d, index) in data.totals" :key="index"
                                :class="{'selected': isSelected(data.dates[index])}">
                                {{ d }}
                            </td>
                        </tr>
                        <tr>
                            <td style="text-transform: uppercase">{{ $t('faults') }}</td>
                            <td v-for="(d, index) in data.faultsTotals" :key="index"
                                :class="{'selected': isSelected(data.dates[index])}">
                                {{ d }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import DateInputHeader from '../part/item/date_input_header';

const ROOM_LABEL_COLUMN_WIDTH = 70;
const GRAPH_COLUMN_WIDTH = 50;

export default {
    name: 'overview-occupancy',
    components: {DateInputHeader},
    data() {
        return {
            loading: false,
            countTodayRemaining: null,
            countTodayTotal: null,
            type: 'free',
            date: new Date(),
            from: undefined,
            to: undefined,
            data: null,
            ROOM_LABEL_COLUMN_WIDTH,
            GRAPH_COLUMN_WIDTH
        }
    },
    created() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
        this.clearResizeDebounceTimer();
    },
    mounted() {
        this.calculateColumnsDates();
        this.loadData()
    },
    watch: {
        date: function () {
            this.clearData()
            this.calculateColumnsDates()
            this.armDebounceTimer()
        },
        type: function () {
            this.clearData()
            this.calculateColumnsDates()
            this.loadData()
        }
    },
    methods: {
        calculateColumnsDates: function () {
            if (this.date) {
                const el = this.$refs['table']
                if (el) {
                    const graphWidth = el.scrollWidth - ROOM_LABEL_COLUMN_WIDTH

                    const dayCount = Math.floor(graphWidth / GRAPH_COLUMN_WIDTH)
                    const leftCount = Math.floor(dayCount / 3);
                    const rightCount = dayCount - leftCount;

                    const referenceDate = moment(this.date).startOf('day')

                    this.from = moment(referenceDate).subtract(leftCount, 'day')
                    this.to = moment(referenceDate).add(rightCount, 'day')
                }
            }
        },
        clearData: function () {
            this.loading = true;
            this.data = null
        },
        loadData: function () {
            this.clearData()

            let query = `{
                occupancyChart(
                  date_from:"${moment(this.from).startOf('day').format('yyyy-MM-DD')}",
                  date_to: "${moment(this.to).startOf('day').format('yyyy-MM-DD')}"
                )

                listRoomTypes {
                  id,
                  code,
                  technical
                }
              }`;

            axios({
                data: query
            }).then(response => {
                const occupancyChartData = JSON.parse(response.data.data.occupancyChart)

                const roomTypes = {}
                response.data.data.listRoomTypes.filter(t => !t.technical).forEach(t => roomTypes[t.id] = t.code)

                const roomTypeCounts = occupancyChartData.room_type_counts
                const roomTypeIds = Object.keys(roomTypeCounts).filter(i => roomTypes[i]) // Jen známé typy
                let totalRoomsCounts = 0
                roomTypeIds.forEach(i => totalRoomsCounts += roomTypeCounts[i])
                const datesData = occupancyChartData.dates
                const dates = Object.keys(datesData)

                this.data = {
                    dates: dates,
                    items: roomTypeIds.map(r =>
                        ({
                            label: roomTypes[r],
                            occupancy: dates.map(d =>
                                this.type === 'occupied' ?
                                    datesData[d].occupied_rooms_by_type[r] :
                                    roomTypeCounts[r] - datesData[d].used_rooms_by_type[r]
                            )
                        })
                    ),
                    faultsTotals: dates.map(d =>
                        datesData[d].faults_total
                    )
                }

                console.log(occupancyChartData)

                this.data.totals = dates.map((d, index) => this.data.items.map(i => i.occupancy[index]).reduce((a, b) => a + b, 0))

                this.data.percentages = dates.map(d => Math.round((this.type === 'occupied' ?
                    datesData[d].occupied_rooms_count :
                    (occupancyChartData.real_room_count - datesData[d].occupied_rooms_count)) * 100 / occupancyChartData.real_room_count))
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.loading = false;
            });
        },
        isSunday: function (date) {
            return moment(date).day() === 0
        },
        isSelected: function (date) {
            return moment(date).isSame(moment(this.date), 'day')
        },
        isToday: function (date) {
            return moment(date).isSame(moment(), 'day')
        },
        day: function (date) {
            return moment(date).format('DD')
        },
        weekDay: function (date) {
            return moment(date).format('dd')
        },
        onResize: function () {
            this.clearData()
            this.calculateColumnsDates()
            this.armDebounceTimer();
        },
        armDebounceTimer: function () {
            this.clearResizeDebounceTimer();
            this.resizeDebounceTimer = setTimeout(() => this.loadData(), 500)
        },
        clearResizeDebounceTimer: function () {
            if (this.resizeDebounceTimer) {
                clearTimeout(this.resizeDebounceTimer)
            }
        },
    }
}
</script>

<style lang="less" scoped>
.comp_overview_occupancy {
    height: 100%;
    display: flex;

    .comp_content {
        height: 100%;
        width: 100%;
        max-width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .header {
            display: flex;
            justify-content: center;
            width: 100%;
            max-width: 800px;
            min-width: 0;
            flex-direction: column;
        }

        .wrp_comp_body {
            align-self: stretch;

            table {
                max-width: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/templates/comp/overview-occupancy.vue